// extracted by mini-css-extract-plugin
export var active = "index-module--active--sxZDX";
export var advantage = "index-module--advantage--dSkoD";
export var agree = "index-module--agree--PcvBZ";
export var btnContent = "index-module--btnContent--Np6eo";
export var choice = "index-module--choice--aIFgm";
export var choicePlatform = "index-module--choicePlatform--HJLu-";
export var choiceSoftwarePackage = "index-module--choiceSoftwarePackage---eT3h";
export var choiceVersion = "index-module--choiceVersion--B4zp5";
export var description = "index-module--description--BpSXj";
export var download_button = "index-module--download_button--e7fgA";
export var historyVersion = "index-module--historyVersion--GO857";
export var isFocused = "index-module--is-focused--2bs+M";
export var linkList = "index-module--linkList--slTqV";
export var newVersion = "index-module--newVersion--K9Da2";
export var radio = "index-module--radio--UoInF";
export var softwarePackage = "index-module--softwarePackage--9r0DD";
export var softwarePackageInner = "index-module--softwarePackageInner--Ji1ls";
export var support = "index-module--support--HL+aZ";
export var support_manual = "index-module--support_manual--gb2hB";
export var support_manual_English = "index-module--support_manual_English--5bXGV";
export var support_os = "index-module--support_os---pMdu";
export var tooltip = "index-module--tooltip--ZmYLI";
export var tooltipInner = "index-module--tooltipInner--yaE3J";
export var tooltipLi = "index-module--tooltipLi--Da-c6";
export var versionSelect = "index-module--versionSelect--EvyYF";
export var warm = "index-module--warm--SBndj";